'use client';
import * as React from 'react';
import * as CollapsiblePrimitive from '@radix-ui/react-collapsible';
const Collapsible = React.forwardRef(({ ...props }, ref) => React.createElement(CollapsiblePrimitive.Root, { ref: ref, "data-slot": "collapsible", ...props }));
Collapsible.displayName = CollapsiblePrimitive.Root.displayName;
const CollapsibleTrigger = React.forwardRef(({ ...props }, ref) => (React.createElement(CollapsiblePrimitive.Trigger, { ref: ref, "data-slot": "collapsible-trigger", ...props })));
CollapsibleTrigger.displayName = CollapsiblePrimitive.Trigger.displayName;
const CollapsibleContent = React.forwardRef(({ ...props }, ref) => (React.createElement(CollapsiblePrimitive.Content, { ref: ref, "data-slot": "collapsible-content", ...props })));
CollapsibleContent.displayName = CollapsiblePrimitive.Content.displayName;
export { Collapsible, CollapsibleTrigger, CollapsibleContent };
